import React from "react";
import { useSelector } from "react-redux";
import Hienxu from "../hienxu.jsx";
import HostnameDropdown from "./nav_down";
import Menu from "./menu";
import TopNavCategories from "./top_nav_categories.jsx";
import Language_i18 from "../../js/useNationalLanguage.jsx";
import { isLocalHost } from "../../shared/host_utils.js";
import { Cookies } from "../../shared/cookies.js";

export default function NavTop({ toggleMenu, domain, handleChange }) {
    const { lang } = Language_i18();
    const latest_version = useSelector((state) => state.latest_version);
    const latestVersionText =
        latest_version === undefined || latest_version === null
            ? ""
            : String(latest_version).trim();
    const hasLatestVersion = latestVersionText !== "";
    const hideNavControls = latestVersionText === "3";
    const hasSidebarReadyCache = (() => {
        try {
            const raw = window.localStorage.getItem("sidebar_menu_test");
            if (!raw) return false;
            const parsed = JSON.parse(raw);
            const menu = Array.isArray(parsed?.menu) ? parsed.menu : [];
            if (menu.length === 0) return false;
            const firstLabel = menu?.[0]?.label;
            return !(typeof firstLabel === "string" && firstLabel.toLowerCase().includes("loading data"));
        } catch {
            return false;
        }
    })();

    const json_navigation = {
        vi: { prev: "Trước", next: "Next" },
        en: { prev: "Back", next: "Next" },
    };

    if (window.location.href.includes("shownav=NO")) return null;

    return (
        <>
            <nav className="sticky top-0 z-40 w-full border-b border-slate-200/80 bg-white text-lg text-gray-700 shadow-none">
                <div className="relative mx-auto flex w-full max-w-[1320px] items-center gap-3 px-2 py-1 md:py-0 lg:px-8 xl:px-12">
                    <div className="flex shrink-0 items-center">
                        <Menu toggleMenu={toggleMenu} />
                        {hasLatestVersion && hasSidebarReadyCache && !hideNavControls ? (
                            <div className="flex items-center" id="menu">
                                <button
                                    className="text-break rounded-l bg-pink-200 px-mot font-bold text-gray-800 hover:bg-pink-400"
                                    onClick={() => window.history.back()}
                                >
                                    <span className="text-xs">{json_navigation[lang]?.prev}</span>
                                </button>
                                <div className="h-6 w-px" />
                                <button
                                    className="text-break rounded-r bg-pink-200 px-mot font-bold text-gray-800 hover:bg-pink-400"
                                    onClick={() => window.history.forward()}
                                >
                                    <span className="text-xs">{json_navigation[lang]?.next}</span>
                                </button>
                            </div>
                        ) : null}
                    </div>

                    {!Cookies.get("apikey") && <TopNavCategories />}

                    <div className="absolute inset-y-0 left-1/2 flex -translate-x-1/2 items-center">
                        <Hienxu />
                    </div>

                    <div className="ml-auto flex shrink-0 items-center gap-2">
                        {isLocalHost(window.location.hostname) && (
                            <div className="flex items-center gap-1 text-xs">
                                <label htmlFor="domain-select">domain:</label>
                                <select id="domain-select" value={domain} onChange={handleChange}>
                                    <option value="hust">HUST</option>
                                    <option value="bird">BIRD</option>
                                    <option value="tecom">TECOM</option>
                                    <option value="nofake">NOFAKE</option>
                                </select>
                            </div>
                        )}
                        <HostnameDropdown />
                    </div>
                </div>
            </nav>
            <div className="layout-overlay layout-menu-toggle" />
        </>
    );
}
